import { configureStore } from '@reduxjs/toolkit'
import userReducer from './redux/slices/userSlice'
import creditReducer from './redux/slices/creditSlice'
import orgReducer from './redux/slices/orgSlice'
import zynthReducer from './redux/slices/zynthSlideSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    credit: creditReducer,
    organization: orgReducer,
     zynth: zynthReducer,
  },
})


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
